import styled from 'styled-components';
import { Grid } from 'semantic-ui-react';
import Button from '../../components/Button';

export const StepIndex = styled.div`
  font-size: 20px;
  padding-left: 10px;

  @media (max-width: 768px) {
    font-size: 18px;
    padding-left: 8px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    padding-left: 6px;
  }
`;

export const StepName = styled.div`
  padding-left: 2px;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const Step = styled.div`
  color: ${(props: { selected: boolean; theme: any }) =>
    props.selected ? 'white' : props.theme.main.color};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${(props: { selected: boolean; theme: any }) =>
    props.selected ? props.theme.main.color : 'white'};
  border: 1px solid
    ${(props: { selected: boolean; theme: any }) =>
    props.selected ? 'white' : props.theme.main.color};
  border-radius: 12px;
  flex: 1;
  height: 55px;
  line-height: 50px;
  text-align: center;
  margin: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.secundary.color};
    color: white;
    border: 1px solid ${props => props.theme.secundary.color};
  }

  @media (max-width: 768px) {
    height: 50px;
    line-height: 46px;
    border-radius: 10px;
    margin: 3px;
  }

  @media (max-width: 480px) {
    height: 46px;
    line-height: 42px;
    border-radius: 8px;
    margin: 2px;
  }
`;

export const Nav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 10px;

  @media (max-width: 768px) {
    padding: 16px 8px;
  }

  @media (max-width: 480px) {
    padding: 12px 6px;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    overflow-x: hidden;
  }
`;

export const RightAlignedButton = styled(Button)`
  float: right;

  @media (max-width: 768px) {
    float: none;
    width: 100%;
    margin-top: 10px;
  }
`;

export const AttachmentsWrapper = styled.div`
  border: 3px dashed #c5c5c5;
  width: 300px;
  padding: 20px;
  display: inline-block;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
    padding: 16px;
    border-width: 2px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const AttachmentsText = styled.p`
  font-size: 20px;
  color: #c5c5c5;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const Disclaimer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: center;
  align-items: center;
  min-height: 60px;
  padding: 18px 24px;
  border-radius: 11px;
  border: 2px solid ${props => props.theme.main.color};

  p {
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0em;

    @media (max-width: 480px) {
      font-size: 13px;
      line-height: 18px;
    }
  }

  time {
    color: ${props => props.theme.main.color};
    font-weight: bold;
  }

 i {
    background: ${props => props.theme.main.color};
    color: white;
    border-radius: 2px;
    box-shadow: 0px 0px 1px ${props => props.theme.main.color};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    padding: 16px 20px;
    min-height: auto;
  }

  @media (max-width: 480px) {
    gap: 12px;
    padding: 12px 16px;
  }
`;

export const FieldLabelContainer = styled.div`
  position: relative;
  .icon-button {
    position: absolute;
    top: 9px;
    right: 6px;
    i {
      color: #a3a3a3;
      &.not-required {
        color: ${props => props.theme.main.color};
      }
    }
  }
`;
export const SympathiseTenantHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e4e4;
  padding: 4px 0;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SympathiseTenantLabel = styled.label`
  font-size: 16px;
  color: #e4e4e4;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  gap: 16px;
  padding: 8px 12px;
  min-height: 44px;

  @media (max-width: 768px) {
    gap: 12px;
    padding: 8px 10px;
  }

  @media (max-width: 480px) {
    gap: 10px;
    padding: 6px 8px;
    flex-wrap: wrap;
  }
`;

// Styled component para Grid.Column de campos de documento (CPF/CNPJ)
// Garante largura adequada em mobile
export const DocumentFieldColumn = styled(Grid.Column)`
  @media (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 0.5rem 1rem !important;
    
    // Garante que dropdown/input ocupem largura total
    .ui.dropdown,
    .ui.input,
    .field {
      width: 100% !important;
      max-width: 100% !important;
    }
    
    // Ajusta altura mínima para touch target
    .ui.dropdown,
    .ui.input input {
      min-height: 44px !important;
      font-size: 16px !important;
    }
    
    // Ajusta menu do dropdown em mobile
    .ui.selection.dropdown .menu {
      max-height: 200px;
    }
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.5rem !important;
    
    .ui.dropdown,
    .ui.input input {
      min-height: 42px !important;
    }
  }
`;

// Styled component para campos de valor/input genéricos
// Faz ficarem 100% width em mobile (um por linha)
export const ResponsiveFieldColumn = styled(Grid.Column)`
  @media (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 0.5rem 1rem !important;
    margin-bottom: 0.5rem !important;
    
    .ui.input,
    .field {
      width: 100% !important;
    }
    
    .ui.input input {
      min-height: 44px !important;
      font-size: 16px !important;
    }
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.5rem !important;
    
    .ui.input input {
      min-height: 42px !important;
    }
  }
`;

// Styled component para Grid.Row que força todas as colunas ficarem 100% em mobile
export const ResponsiveRow = styled(Grid.Row)`
  @media (max-width: 768px) {
    display: flex !important;
    flex-direction: column !important;
    
    > .column,
    > [class*="column"] {
      width: 100% !important;
      max-width: 100% !important;
      flex: 0 0 100% !important;
      padding: 0.5rem 1rem !important;
      margin-bottom: 0.5rem !important;
    }
    
    .ui.input,
    .ui.input input,
    .field,
    .ui.dropdown,
    .ui.selection.dropdown {
      width: 100% !important;
      min-height: 44px !important;
      font-size: 16px !important;
    }
  }

  @media (max-width: 480px) {
    > .column,
    > [class*="column"] {
      padding: 0.5rem 0.5rem !important;
    }
    
    .ui.input input,
    .ui.dropdown {
      min-height: 42px !important;
    }
  }
`;

export const SpacedColumn = styled(Grid.Column)`
  @media (max-width: 768px) {
    margin-bottom: 1rem !important;
  }
`;
